import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';
import { ContentAuthoringService } from "../../services/content-authoring.service";

@Component({
  selector: 'app-course-add-assign-user',
  templateUrl: './course-add-assign-user.component.html',
  styleUrls: ['./course-add-assign-user.component.scss']
})
export class CourseAddAssignUserComponent implements OnInit {
  closeResult = '';
  adminData:any;courseId:any='';tab:any='';userData:any;organisationData:any;selectUserId:any=[];
  constructor(private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,private toastr: ToastrService,private authCourse:CourseService,private contentAuthoringApi:ContentAuthoringService) {}
    searchText:any="";order_by='created_dttm';filter_by:any="";is_active:any='1';order:any='DESC';user_type:number=1
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  getUsersDetailss(searchText:any,is_active:any,order_by:any,order:any,filter_by:any, user_type:any){
 // this.spinner.show();
    this.contentAuthoringApi.getUserList(searchText,is_active,order_by,order,filter_by, user_type).subscribe(
      data=>{
        this.userData = data.userList
        this.checkBoxHandler(this.userData)
       // this.spinner.hide();
      },error=>{
        //this.spinner.hide();

      }
    )
  }
  getUsersDetails(searchText:any,is_active:any,order_by:any,order:any,filter_by:any){
     this.spinner.show();
       this.contentAuthoringApi.getUserList(searchText,is_active,order_by,order,filter_by, this.user_type).subscribe(
         data=>{
          // console.log(data);
           this.userData = data.userList
           this.checkBoxHandler(this.userData)
           this.spinner.hide();
         },error=>{
           this.spinner.hide();
   
         }
       )
     }
    selectChangeHandler (event: any) {
      this.filter_by=event.target.value;
      if(this.filter_by == 0){
        this.filter_by='';
        this.getUsersDetails(this.searchText,this.is_active,this.order_by,this.order,this.filter_by);
      }else{
        this.getUsersDetails(this.searchText,this.is_active,this.order_by,this.order,this.filter_by);
      }
    }
  search(event: any) {
    this.searchText=event.target.value;
    this.getUsersDetailss(this.searchText,this.is_active,this.order_by,this.order,this.filter_by, this.user_type);
   }
  //  sorting(event: any) {
  //   this.searchText=event.target.value;
  //   this.getUsersDetails(this.searchText,this.is_active,this.order_by,this.order,this.filter_by);
  //  }
   sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    this.getUsersDetails(this.searchText,this.is_active,this.order_by,this.order,this.filter_by);
  }
   getOrganisationList(is_active:any){
    this.contentAuthoringApi.getOrganisationList("",is_active,this.order_by,this.order).subscribe(
      (data)=>{
      if(data.success){
       // console.log(data)
        this.organisationData= data.organisationList;
      }else{
        //this.errorInfo.isError = true;
       // this.errorInfo.errorMsg = 'No data Exist';
      }
      },
      (error) => { 
       // this.errorInfo.errorMsg = error;
       },
    );
  }
  cancelCourse(){
    this.authCourse.deletesCourse(this.courseId).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('CloseIds')?.click();
          this.router.navigate(['/courses']);
        } else {
          //this.errorInfo.isError = true;
          //this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  publish(){
   // console.log(this.selectUserId);
    this.authCourse.AssignUsers(this.courseId,this.selectUserId).subscribe(
      (data)=>{
       // console.log(data)
      //if(data.success){
        document.getElementById('CloseIds')?.click();
        this.router.navigate(['/courses_published'],{ queryParams: { courseId: this.courseId} });
        //console.log(data)
        //this.organisationData= data.organisationList;
      //}else{
        //this.errorInfo.isError = true;
       // this.errorInfo.errorMsg = 'No data Exist';
      //}
      },
      (error) => { 
       // alert("hello");
       // this.errorInfo.errorMsg = error;
       },
    );
  }
  logout(){
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   }
  cancelbkModule(){
    document.getElementById('CloseIds')?.click();
    this.router.navigate(['/courses_add_review'],{ queryParams: { courseId: this.courseId } });
  }
  ngOnInit(): void {
    this.getOrganisationList(this.is_active);
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
    });
    this.getUsersDetails(this.searchText,this.is_active,this.order_by,this.order,this.filter_by);
  }
  onChangeDemo(e:any,Id:any,index:any) {
     if(e.checked == true){
       // alert(Id)
        this.selectUserId[index] = Id;
       
     }else{
      const index = this.selectUserId.indexOf(Id);
      this.selectUserId.splice(index, 1);

     }
    // console.log(this.selectUserId);
    
 } 
 checkBoxHandler(userData:any){
  for (let i = 0; i < userData.length; i++) {
    if(this.selectUserId.indexOf(userData[i].user_id) !=-1)
     userData[i]["checked"]=true;
     else{
       userData[i]["checked"]=false;
     }
     
   }
}
}
